import { useState } from "react";
import { Modal, ModalHeader } from "reactstrap";
import { Btn, H3, P } from "../../../../../AbstractElements";
import RegisterUserForm from "./RegisterUserForm";
import { UserPlus } from "react-feather";

const RegisterUserModal = () => {
  const [modal, setModal] = useState(false);
  const toggle = () => setModal(!modal);

  return (
    <>
      <Btn color="primary" onClick={toggle}>
        <UserPlus size={13} /> Register User
      </Btn>
      <Modal isOpen={modal} toggle={toggle}>
        <div className="modal-toggle-wrapper social-profile text-start dark-sign-up">
          <ModalHeader className="border-0">
            <H3>Register New Account</H3>
            <P className="f-w-300" style={{ margin: 0 }}>
              Fill in the details below.
            </P>
          </ModalHeader>
          <RegisterUserForm toggle={toggle} />
        </div>
      </Modal>
    </>
  );
};
export default RegisterUserModal;
